import React from 'react';
import { connect } from 'react-redux';

import Link from '../components/Link';

import { setRedirect, setFullWidth } from '../reducers/navigation';

import { URL_WELCOME } from '../config/urls';
import { ANIMATION_SLIDE_IN } from '../config/transitions';

const mapStateToProps = (state, ownProps) => ({
  campaignLogoLanding: state.user.campaignLogoLanding,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  setFullWidth: val => dispatch(setFullWidth(val)),
  setRedirect: val => dispatch(setRedirect(val)),
  dispatch
})

class Landing extends React.Component {
  componentWillMount() {
    const { setFullWidth } = this.props;

    setFullWidth(false);
  }

  goIntroduction() {
    const { setRedirect } = this.props;
    const nextScreen = {
      route: URL_WELCOME,
      animation: ANIMATION_SLIDE_IN
    };

    setRedirect(nextScreen);
  }

  render() {
    const { campaignLogoLanding, campaignData } = this.props;

    const activeModule = campaignData.modules.coreModulesPre.filter(
      module => module.id === "core-landing"
    )[0];

    return (
      <div className="screen landing instructions">
        <div className="version">0.1.0</div>
        <div className="screen-inner-wrapper">
          {(
            (campaignData.design.landingLogoType === "image" && campaignLogoLanding) ||
            (campaignData.design.landingLogoType === "text" && campaignData.design.landingLogoText )
          ) && (
            <div className="flexible-top">
              {campaignData.design.landingLogoType === "image" && campaignLogoLanding && (
                <img className="logo-big" src={campaignLogoLanding} alt="Sounditi logo" />
              )}
              {campaignData.design.landingLogoType === "text" &&
              campaignData.design.landingLogoText && (
                <div className="flexible-center">
                  <div className="logo-text">{campaignData.design.landingLogoText}</div>
                </div>
              )}
            </div>
          )}
          <div className="fixed-bottom">
            {activeModule.title && (
              <h1>{activeModule.title}</h1>
            )}
            {activeModule.text && (
              <p>{activeModule.text}</p>
            )}
            <Link onClick={() => this.goIntroduction()}>{activeModule.button}</Link>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Landing)
